__turbopack_context__.v({
  "boxWrapper": "ServiceFeatureCard-module-scss-module__J0X3jG__boxWrapper",
  "chip": "ServiceFeatureCard-module-scss-module__J0X3jG__chip",
  "chipBlue": "ServiceFeatureCard-module-scss-module__J0X3jG__chipBlue",
  "chipGreen": "ServiceFeatureCard-module-scss-module__J0X3jG__chipGreen",
  "chipOrange": "ServiceFeatureCard-module-scss-module__J0X3jG__chipOrange",
  "chipPink": "ServiceFeatureCard-module-scss-module__J0X3jG__chipPink",
  "chips": "ServiceFeatureCard-module-scss-module__J0X3jG__chips",
  "container": "ServiceFeatureCard-module-scss-module__J0X3jG__container",
  "content": "ServiceFeatureCard-module-scss-module__J0X3jG__content",
  "description": "ServiceFeatureCard-module-scss-module__J0X3jG__description",
  "image": "ServiceFeatureCard-module-scss-module__J0X3jG__image",
  "reverse": "ServiceFeatureCard-module-scss-module__J0X3jG__reverse",
  "visible": "ServiceFeatureCard-module-scss-module__J0X3jG__visible",
});
